<template>
  <div class="p-4">
    <button @click="createNewSubCategory" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Sub Category
    </button>
    <el-table
      :data="subCategories"
      :empty-text="'No Sub Category available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name">
      </el-table-column>
      <el-table-column
        prop="category"
        label="Category"
        width="280">
      </el-table-column>
      <el-table-column
        prop="image"
        label="Image">
        <template slot-scope="scope">
          <a class="text-blue-500 italic hover:underline" v-if="scope.row.image" :href="scope.row.image" target="_blank">
            <img :src=scope.row.image>
          </a>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="">
        <template slot-scope="scope">
          <router-link :to="{name: 'micro-category', params: {category_id: scope.row.category_id, subCategory_id: scope.row.id }}">
            <i class="text-sm mr-2 text-gray-500 el-icon-view"></i>
          </router-link>
          <el-button type="text" @click="update(scope.row)" size="small">
            <i class="text-sm el-icon-edit"></i>
          </el-button>
          <el-button @click="deleteSubCategory(scope.row.id, scope.row.category_id)" type="text" size="small">
            <i class="text-sm text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <CreateForm @imageUpload="imageUpload" />
    <UpdateForm :upload_url="url" />
  </div>
</template>

<script>
import { flatMap } from 'lodash';
import CreateForm from './_includes/SubCategory/CreateForm.vue';
import UpdateForm from './_includes/SubCategory/UpdateForm.vue';

export default {
  name: 'SubCategory',
  components: {
    CreateForm,
    UpdateForm,
  },
  data() {
    return {
      url: '',
    };
  },
  computed: {
    subCategories() {
      if (this.$route.params.id) {
        return this.$store.getters['InventoryModule/Catalog/getSubCategoryByCategory'](this.$route.params.id);
      }
      return flatMap(this.$store.state.InventoryModule.Catalog.subCategories);
    },
  },
  methods: {
    createNewSubCategory() {
      this.$modal.show('new-sub-category');
    },

    viewDetails(categoryId, subCategoryId) {
      this.$router.push(`/ecommerce/inventory/category/${categoryId}/subcategory/${subCategoryId}/micro-category`);
    },

    update(subCategory) {
      this.url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${subCategory.id}/images?type=sub_categories`;
      this.$store.commit('InventoryModule/Catalog/setCurrentSelected', { property: 'subCategory', payload: subCategory });
      this.$modal.show('update-sub-category');
    },
    deleteSubCategory(subCategoryId, categoryId) {
      this.$confirm('This will permanently delete the sub-category and micro-categories under it. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Catalog/deleteSubCategory', { subCategoryId, categoryId });
          this.$notify.success({
            title: 'Success',
            message: 'Category successfully deleted',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },

    imageUpload(id) {
      this.$modal.hide('new-sub-category');
      this.$modal.show('image-upload');

      this.url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${id}/images?type=sub_categories`;
    },
  },
};
</script>

<style scoped>
  img {
    height: 50px;
    width: 70px;
    border-radius: 4px;
    object-fit: cover;
  }
</style>
